import { notificationUtils } from './notifications';

class PriceAlertManager {
  constructor() {
    this.alerts = this.loadAlerts();
    this.lastPrice = null;
    this.checkInterval = null;
  }

  loadAlerts() {
    try {
      const stored = localStorage.getItem('priceAlerts');
      return stored ? JSON.parse(stored) : [];
    } catch (error) {
      return [];
    }
  }

  saveAlerts() {
    try {
      localStorage.setItem('priceAlerts', JSON.stringify(this.alerts));
    } catch (error) {
      // Silent fail for localStorage errors
    }
  }

  addAlert(targetPrice, direction = 'above') {
    const alert = {
      id: Date.now().toString(),
      targetPrice: parseFloat(targetPrice),
      direction, // 'above' or 'below'
      active: true,
      createdAt: Date.now(),
      triggeredAt: null
    };
    
    this.alerts.push(alert);
    this.saveAlerts();
    return alert;
  }

  removeAlert(alertId) {
    this.alerts = this.alerts.filter(alert => alert.id !== alertId);
    this.saveAlerts();
  }

  toggleAlert(alertId) {
    const alert = this.alerts.find(a => a.id === alertId);
    if (alert) {
      alert.active = !alert.active;
      this.saveAlerts();
    }
  }

  getActiveAlerts() {
    return this.alerts.filter(alert => alert.active);
  }

  getAllAlerts() {
    return this.alerts;
  }

  checkAlerts(currentPrice) {
    if (!currentPrice || !this.lastPrice) {
      this.lastPrice = currentPrice;
      return;
    }

    const activeAlerts = this.getActiveAlerts();
    
    activeAlerts.forEach(alert => {
      const shouldTrigger = 
        (alert.direction === 'above' && this.lastPrice <= alert.targetPrice && currentPrice > alert.targetPrice) ||
        (alert.direction === 'below' && this.lastPrice >= alert.targetPrice && currentPrice < alert.targetPrice);

      if (shouldTrigger) {
        // Send notification
        notificationUtils.showPriceNotification(currentPrice, alert.targetPrice, alert.direction);
        
        // Mark as triggered
        alert.triggeredAt = Date.now();
        alert.active = false; // Disable after triggering
        this.saveAlerts();
      }
    });

    this.lastPrice = currentPrice;
  }

  startMonitoring(getPriceCallback, interval = 5000) {
    if (this.checkInterval) {
      clearInterval(this.checkInterval);
    }

    // Initial check
    const price = getPriceCallback();
    if (price) {
      this.checkAlerts(price);
    }

    // Set up interval
    this.checkInterval = setInterval(() => {
      const price = getPriceCallback();
      if (price) {
        this.checkAlerts(price);
      }
    }, interval);
  }

  stopMonitoring() {
    if (this.checkInterval) {
      clearInterval(this.checkInterval);
      this.checkInterval = null;
    }
  }
}

// Create singleton instance
export const priceAlertManager = new PriceAlertManager();